import React from 'react';
import { useTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import { makeStyles } from '@material-ui/core/styles';
import { useTheme } from '@material-ui/core/styles';
import { addAllList } from 'modules/common';

import MbTooltip from 'components/atoms/MbTooltip';
import NewButton from 'components/molecules/NewButton';
import NewFilterWrap from 'components/molecules/NewFilterWrap';
import NewCommonFilter from 'components/organisms/NewCommonFilter';
import FilterCollection from 'components/organisms/FilterCollection';

const useStyles = makeStyles((theme) => ({
  colorBoxWrap: { display: 'flex', padding: 10 },
  colorBox: {
    width: 20,
    height: 20,
    marginRight: 10,
    borderRadius: '50%',
    cursor: 'pointer',
    '&:last-child': { marginRight: 0 },
  },
}));

const TargetStatisticsFilters = (props) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const theme = useTheme();

  const {
    handleOnReset,
    tempParams,
    handleColorBox,
    handleLabelConver,
    getTempParam,
    filterList,
    mediaCharacterTpCodeList,
    admContactList,
    contactList,
    colorBoxOpen,
    getParam,
    initialization,
    handleOnReSearch,
  } = props;
  const isContactNo = !!tempParams.contactNo;

  return (
    <NewFilterWrap
      handleOnReset={handleOnReset}
      handleOnReSearch={handleOnReSearch}
    >
      <NewCommonFilter
        initialization={initialization}
        params={tempParams}
        getParam={getTempParam}
        useExternalFilter={false}
        useTracker
        pltfomTpCodeDetailFilter={['03', '04']}
      />
      <FilterCollection
        label={t('외부연동')}
        name="itlTpCode"
        params={tempParams}
        value={tempParams.itlTpCode}
        type="radio"
        list={[
          { label: '포함', value: 'all' },
          { label: '제외', value: '01,03,04,05,08,09,10,11,12,13' },
        ]}
        callBack={getTempParam}
        labelKey="label"
        valueKey="value"
      />
      <FilterCollection
        label={t('지면효율등급필터')}
        name="parRnk"
        params={tempParams}
        value={tempParams.parRnk}
        type="checkbox"
        list={filterList.parRnk}
        callBack={getTempParam}
        labelKey="label"
        valueKey="value"
      />
      <FilterCollection
        label={t('정산 등급 필터')}
        name="grade"
        params={tempParams}
        value={tempParams.grade}
        type="checkbox"
        list={filterList.grade}
        callBack={getTempParam}
        labelKey="label"
        valueKey="value"
      />
      <FilterCollection
          label={t('특수지면')}
          name="spclTpCode"
          params={tempParams}
          value={tempParams.spclTpCode}
          type="checkbox"
          list={[
            { label: '모비온 리워드 지면', value: '01' },
            { label: '동영상 지면', value: '02' },
            { label: '스와이프 지면', value: '03' },
          ]}
          callBack={getTempParam}
          labelKey="label"
          valueKey="value"
      />
      <FilterCollection
          label={t('지면 특성')}
          name="mediaCharacterTpCode"
          params={tempParams}
          value={tempParams.mediaCharacterTpCode}
          type="checkbox"
          list={mediaCharacterTpCodeList}
          callBack={getTempParam}
          labelKey="CODE_DESC"
          valueKey="CODE_ID"
      />
      <FilterCollection
        label={t('영업 담당자')}
        name={!!tempParams.contactNo ? 'contactNo' : 'contactUserId'}
        params={tempParams}
        value={isContactNo ? tempParams.contactNo : tempParams.contactUserId}
        type="select"
        list={
          isContactNo
            ? addAllList(contactList, 'USER_NAME', 'CONTACT_NO', 'all')
            : addAllList(contactList, 'USER_NAME', 'USER_ID', 'all')
        }
        callBack={getTempParam}
        labelKey="USER_NAME"
        valueKey={isContactNo ? 'CONTACT_NO' : 'USER_ID'}
      />
      <FilterCollection
        label={t('어드민 담당자')}
        name="admContact"
        params={tempParams}
        value={tempParams.admContact}
        type="select"
        list={addAllList(admContactList, 'USER_NAME', 'USER_ID', 'all')}
        callBack={getTempParam}
        labelKey="USER_NAME"
        valueKey="USER_ID"
      />
      <FilterCollection
        label={t('오픈 RTB')}
        name="itlTpCode"
        params={tempParams}
        value={tempParams.itlTpCode}
        type="radio"
        list={[
          { label: '포함', value: 'all' },
          { label: '제외', value: '01,02,98,99' },
        ]}
        callBack={getTempParam}
        labelKey="label"
        valueKey="value"
      />
      <FilterCollection
        label={t('지급률')}
        name="prRankTpCode"
        filtered={tempParams['prRankTpCode'] !== 'all'}
        selectLabel={handleLabelConver('prRankTpCode')}
        open={colorBoxOpen}
      >
        <div className={classes.colorBoxWrap}>
          <MbTooltip
            title="적용안함"
            className={classes.colorBox}
            style={{ border: '1px solid #ccc' }}
            onClick={(f) => handleColorBox('prRankTpCode', 'all')}
          />
          <MbTooltip
            title="66% 이상"
            className={classes.colorBox}
            style={{ backgroundColor: theme.palette.common.red }}
            onClick={(f) => handleColorBox('prRankTpCode', '01')}
          />
          <MbTooltip
            title="51% ~ 65%"
            className={classes.colorBox}
            style={{ backgroundColor: theme.palette.common.yellow }}
            onClick={(f) => handleColorBox('prRankTpCode', '02')}
          />
          <MbTooltip
            title="50% 이하"
            className={classes.colorBox}
            style={{ backgroundColor: theme.palette.common.green }}
            onClick={(f) => handleColorBox('prRankTpCode', '03')}
          />
        </div>
      </FilterCollection>
      <FilterCollection
        label={t('세션쇼핑ROAS')}
        name="ssrTpCode"
        filtered={tempParams['ssrTpCode'] !== 'all'}
        selectLabel={handleLabelConver('ssrTpCode')}
        open={colorBoxOpen}
      >
        <div className={classes.colorBoxWrap}>
          <MbTooltip
            title="적용안함"
            className={classes.colorBox}
            style={{ border: '1px solid #ccc' }}
            onClick={(f) => handleColorBox('ssrTpCode', 'all')}
          />
          <MbTooltip
            title="50% 미만"
            className={classes.colorBox}
            style={{ backgroundColor: '#a566ff' }}
            onClick={(f) => handleColorBox('ssrTpCode', '01')}
          />
          <MbTooltip
            title="50% 이상 ~ 100% 미만"
            className={classes.colorBox}
            style={{ backgroundColor: '#f781d8' }}
            onClick={(f) => handleColorBox('ssrTpCode', '02')}
          />
          <MbTooltip
            title="100% 이상 ~ 200% 미만"
            className={classes.colorBox}
            style={{ backgroundColor: '#f7a35c' }}
            onClick={(f) => handleColorBox('ssrTpCode', '03')}
          />
          <MbTooltip
            title="200% 이상 ~ 500% 미만"
            className={classes.colorBox}
            style={{ backgroundColor: '#90ed7d' }}
            onClick={(f) => handleColorBox('ssrTpCode', '04')}
          />
          <MbTooltip
            title="500% 이상"
            className={classes.colorBox}
            style={{ backgroundColor: '#0174df' }}
            onClick={(f) => handleColorBox('ssrTpCode', '05')}
          />
        </div>
      </FilterCollection>
      <NewButton onClick={() => getParam(tempParams, 'filter')} disableRipple>
        {t('검색')}
      </NewButton>
    </NewFilterWrap>
  );
};

const isEqual = (prefProps, nextProps) => {
  let equal = JSON.stringify(prefProps) !== JSON.stringify(nextProps);
  return !equal;
};

export default React.memo(withRouter(TargetStatisticsFilters), isEqual);
